<template functional>
  <address>
    <div>{{ $options.fullName(props.address) }}</div>
    <div>{{ props.address.addressLine1 }}</div>
    <div v-if="props.address.addressLine2">
      {{ props.address.addressLine2 }}
    </div>
    <div v-if="$options.organisation(props.address)">
      {{$options.organisation(props.address)}}
    </div>
    <div>{{ props.address.zipCode }} {{ props.address.city }}</div>
    <div>{{ $options.country(props.address) }}</div>

    <div v-if="props.address.phoneNumber1">
      {{ $options.telephoneNumber(props.address.phoneNumber1, props.address.phoneNumber1Type, parent.$t('label.telephoneNumber')) }}
    </div>
    <div v-if="props.address.phoneNumber2">
      {{ $options.telephoneNumber(props.address.phoneNumber2, props.address.phoneNumber2Type, parent.$t('label.telephoneNumber')) }}
    </div>
  </address>
</template>

<script>
export default {
  name: 'BaseAddress',
  props: {
    address: {
      required: true,
      type: Object
    }
  },

  fullName (address) {
    return [address.title, address.firstName, address.middleName, address.lastName].filter(Boolean).join(' ')
  },

  country (address) {
    return [address.stateProvince, address.countryIso3166Alpha2].filter(Boolean).join(', ')
  },

  organisation (address) {
    return [address.organisation, address.department].filter(Boolean).join(', ')
  },

  telephoneNumber (number, type, label) {
    const validType = type && type !== 'Unknown'

    return [validType ? type : '', `${label}:`, number].filter(Boolean).join(' ')
  }

}
</script>
